import type { LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';

type GatewayMethodCardProps = {
  icon: LucideIcon;
  /** O checkbox "oferecer" da forma. */
  offerControl: ReactNode;
  /** As variações da forma (cartão e PIX); ausente no Boleto PIX. */
  variation?: ReactNode;
  /** Linhas ativas do catálogo que representam a forma ("10101 · PIX"). */
  catalogRows: string[];
  missingInCatalog: boolean;
  isOffered: boolean;
};

/** Um cartão por forma do gateway: oferecer ou não, a variação e o que o catálogo tem para ela. */
export function GatewayMethodCard({
  icon: Icon,
  offerControl,
  variation,
  catalogRows,
  missingInCatalog,
  isOffered,
}: GatewayMethodCardProps) {
  return (
    <div className='flex flex-col gap-3 border-t border-alba-gray-200 pt-4 first:border-t-0 first:pt-0'>
      <div className='flex items-center gap-2'>
        <Icon
          aria-hidden='true'
          className='h-4 w-4 shrink-0 text-alba-blue-500'
          strokeWidth={1.8}
        />
        <div className='min-w-0'>{offerControl}</div>
      </div>

      <div className='flex flex-col gap-3 pl-6'>
        {missingInCatalog ? (
          <p
            className={`text-sm ${isOffered ? 'text-alba-warning-orange-600' : 'text-alba-gray-500'}`}
          >
            Nenhuma forma ativa no catálogo com este uso — o corretor não vai
            vê-la no combo da proposta.
          </p>
        ) : (
          <p className='text-sm text-alba-gray-600'>
            No catálogo:{' '}
            <span className='text-alba-black-500'>
              {catalogRows.join(', ')}
            </span>
          </p>
        )}
        {variation}
      </div>
    </div>
  );
}
